import React, { useState } from "react";
import { View } from "react-native";
import { colors, global } from "../../../const";
import { PrimarySubtitle, PrimaryTitle } from "../../labels";
import { TextInput } from "..";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import localize from "../../../localize";

export default function PasswordInput({ error, progress, progressVisible, ...others }) {

    const [state, setState] = useState({
        isVisible: true
    })

    const ProgressBar = ({ index, left, right }) => {
        return (
            <View
                style={[{
                    height: 6,
                    width: "18%",
                    backgroundColor: progress >= index ? colors.darkgreen : colors.lightGray
                }, left && { borderTopLeftRadius: 6, borderBottomLeftRadius: 6 }, right && { borderBottomRightRadius: 6, borderTopRightRadius: 6 }]}
            />
        )
    }

    return (
        <>
            <TextInput
                {...others}
                secureTextEntry={state.isVisible}
                right={(
                    <Icon
                        icon={state.isVisible ? faEye : faEyeSlash}
                        style={{fontSize: 18}}
                        color={colors.midnightBack}
                        onClick={() => setState({ isVisible: !state.isVisible })}
                    />
                )}
            />
            {
                progressVisible ?
                    (
                        <View style={{ paddingHorizontal: 5 }}>
                            <View style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginVertical: 8 }}>
                                <ProgressBar index={1} left />
                                <ProgressBar index={2} />
                                <ProgressBar index={3} />
                                <ProgressBar index={4} />
                                <ProgressBar index={5} right />
                            </View>
                            <PrimarySubtitle>
                                {error ? error : localize.Must_be_a_minimum}
                            </PrimarySubtitle>
                        </View>
                    )
                    :
                    error && (
                        <PrimaryTitle color={colors.alert} size={13}>
                            {error}
                        </PrimaryTitle>
                    )
            }

        </>
    )
}